import gql from 'graphql-tag'

export default gql`mutation authenticateOptIn($mobile_number: String!, $email: String!, $license_number: String!, $last_name: String!, $first_name: String) {
	authenticateOptIn(mobile_number: $mobile_number, email: $email, license_number: $license_number, last_name: $last_name, first_name: $first_name) {
    status
  }
}`
